<script lang="ts">
export default {
    name: 'BaseBreadcrumbsDivider',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import isObject from 'lodash-es/isObject';

const props = withDefaults(defineProps<{
    divider: string | object;
}>(), {
    divider: '/',
});

const isIcon = computed(() => isObject(props.divider));
</script>

<template>
    <div class="flex justify-center items-center text-current opacity-50 mx-3">
        <base-icon
            v-if="isIcon"
            :class="divider.class"
            :name="divider.name"
            :prefix="divider.prefix"
        />
        <span v-else v-text="divider" />
    </div>
</template>
